import { datadogLogs } from '@datadog/browser-logs';
import { createPIIExcludedLeadLog } from '../create-pii-excluded-lead-log';
export var logInvokedLeadRequest = function (payload) {
    datadogLogs.logger.info('Lead request invoked.', {
        leadData: createPIIExcludedLeadLog(payload),
    });
};
export var logSuccessfulLeadRequest = function (payload, response) {
    datadogLogs.logger.info('Lead request successful.', {
        leadData: createPIIExcludedLeadLog(payload),
        response: response,
    });
};
export var logFailedLeadRequest = function (payload, error) {
    datadogLogs.logger.error('Lead request failed.', {
        leadData: createPIIExcludedLeadLog(payload),
    }, error);
};
//# sourceMappingURL=index.js.map